'use client';
import React, { useState } from 'react';
import LoginForm from './LoginForm';
import SignUpForm from './SignUpForm';
import AppLogo from '@/components/ui/AppLogo';
import { ShieldCheck, TrendingUp, Users, DollarSign } from 'lucide-react';

const stats = [
{ id: 'stat-clientes', icon: Users, value: '247', label: 'Clientes activos' },
{ id: 'stat-capital', icon: DollarSign, value: 'Lps 500,050', label: 'Capital gestionado' },
{ id: 'stat-tasa', icon: TrendingUp, value: '98.4%', label: 'Tasa de recuperación' },
{ id: 'stat-seguro', icon: ShieldCheck, value: '100%', label: 'Transacciones seguras' }];


export default function AuthScreen() {
  const [tab, setTab] = useState<'login' | 'signup'>('login');

  return (
    <div className="min-h-screen flex">
      {/* Left panel — brand */}
      <div className="hidden lg:flex lg:w-1/2 xl:w-[55%] gradient-primary flex-col justify-between p-10 xl:p-14 relative overflow-hidden">
        {/* Background decoration */}
        <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-white/5 -translate-y-1/2 translate-x-1/2" />
        <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full bg-white/5 translate-y-1/2 -translate-x-1/2" />

        {/* Logo */}
        <div className="flex items-center gap-3 relative z-10">
          <AppLogo size={44} />
          <div>
            <span className="font-extrabold text-2xl text-white tracking-tight block">PrestaMass</span>
            <span className="text-white/60 text-xs">Sistema de Gestión de Préstamos</span>
          </div>
        </div>

        {/* Hero text */}
        <div className="relative z-10 space-y-4">
          <h2 className="text-3xl xl:text-4xl font-800 text-white leading-tight">
            Administra tu empresa<br />de préstamos con<br />
            <span className="text-blue-200">total control</span>
          </h2>
          <p className="text-white/70 text-base max-w-sm leading-relaxed">Clientes, préstamos, cuotas, pagos, mora y capital todo en un solo sistema diseñado para Honduras.


          </p>
        </div>

        {/* Stats grid */}
        <div className="relative z-10 grid grid-cols-2 gap-3">
          {stats?.map((stat) =>
          <div key={stat?.id} className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/10">
              <stat.icon size={18} className="text-blue-200 mb-2" />
              <p className="text-xl font-800 text-white tabular-nums">{stat?.value}</p>
              <p className="text-white/60 text-xs mt-0.5">{stat?.label}</p>
            </div>
          )}
        </div>
      </div>
      {/* Right panel — form */}
      <div className="flex-1 flex flex-col justify-center items-center p-6 sm:p-10 bg-background">
        {/* Mobile logo */}
        <div className="flex items-center gap-2.5 mb-8 lg:hidden">
          <AppLogo size={36} />
          <span className="font-extrabold text-xl text-primary tracking-tight">PrestaMass</span>
        </div>

        <div className="w-full max-w-md">
          {/* Tabs */}
          <div className="flex bg-muted rounded-xl p-1 mb-8">
            <button
              onClick={() => setTab('login')}
              className={`flex-1 py-2.5 text-sm font-600 rounded-lg transition-all ${
              tab === 'login' ? 'bg-card card-shadow text-foreground' : 'text-muted-foreground hover:text-foreground'}`
              }>

              Iniciar sesión
            </button>
            <button
              onClick={() => setTab('signup')}
              className={`flex-1 py-2.5 text-sm font-600 rounded-lg transition-all ${
              tab === 'signup' ? 'bg-card card-shadow text-foreground' : 'text-muted-foreground hover:text-foreground'}`
              }>

              Crear cuenta
            </button>
          </div>

          {tab === 'login' ? <LoginForm /> : <SignUpForm onSwitchToLogin={() => setTab('login')} />}
        </div>
      </div>
    </div>);

}